export const fadeOutKeyframes = {
  '@keyframes fadeOut': {
    '0%': { opacity: 1 },
    '100%': { opacity: 0 },
  },
};

export const fadeInKeyframes = {
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
};

export const ANIMATIONS = {
  container: {
    fadeIn: {
      animation: 'fadeIn 500ms ease-in-out',
      keyframes: fadeInKeyframes,
    },
  },
  evaIcon: {
    slideInBounce: {
      animation:
        'slideInBounce 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards, pulse 1.5s ease-in-out infinite',
      cartAnimation:
        'slideInBounceCart 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards, pulse 1.5s ease-in-out infinite',
      pulseAnimation: 'pulse 1.5s ease-in-out infinite',
      keyframes: {
        '@keyframes slideInBounce': {
          '0%': {
            transform: 'translateX(200px) rotate(360deg)',
            opacity: 0,
          },
          '60%': {
            transform: 'translateX(0) rotate(0deg)',
            opacity: 1,
          },
          '80%': {
            transform: 'translateX(-8px) rotate(0deg)',
            opacity: 1,
          },
          '100%': {
            transform: 'translateX(0) rotate(0deg)',
            opacity: 1,
          },
        },
        '@keyframes slideInBounceCart': {
          '0%': {
            transform: 'translateX(500px) rotate(360deg)',
            opacity: 0,
          },
          '60%': {
            transform: 'translateX(0) rotate(0deg)',
            opacity: 1,
          },
          '80%': {
            transform: 'translateX(-8px) rotate(0deg)',
            opacity: 1,
          },
          '100%': {
            transform: 'translateX(0) rotate(0deg)',
            opacity: 1,
          },
        },
        '@keyframes pulse': {
          '0%, 100%': {
            boxShadow: '0 0 0 0 rgba(230,173,255, 0)',
          },
          '50%': {
            boxShadow: '0 0 0 8px rgba(230,173,255, 0.4)',
          },
        },
      },
    },
  },
  // Center content animations
  centerContent: {
    center: {
      animation: 'centerContent 500ms ease-out 200ms both',
      keyframes: {
        '@keyframes centerContent': {
          '0%': { transform: 'translateX(0)' },
          '100%': { transform: 'translateX(0)' },
        },
      },
    },
  },
  // Button animations
  button: {
    fadeIn: {
      animation: 'fadeIn 500ms ease-in-out 200ms both',
      keyframes: fadeInKeyframes,
    },
    fadeOut: {
      animation: 'fadeOut 500ms ease-in-out both',
      keyframes: fadeOutKeyframes,
    },
  },
  // Background highlight animations
  backgroundHighlight: {
    fadeIn: {
      animation: 'backgroundFadeIn 500ms ease-in 1s both',
      keyframes: {
        '@keyframes backgroundFadeIn': {
          '0%': { backgroundColor: 'transparent' },
          '100%': { backgroundColor: 'violet.lighter' },
        },
      },
    },
    growFromLeft: {
      animation: 'growFromLeft 500ms ease-in 1s both',
      keyframes: {
        '@keyframes growFromLeft': {
          '0%': { width: '0%' },
          '100%': { width: '100%' },
        },
      },
    },
  },
  // Text animations
  text: {
    fadeIn: {
      animation: 'fadeIn 500ms ease-in-out 200ms both',
      keyframes: fadeInKeyframes,
    },
    fadeInAccepted: {
      animation: 'fadeIn 500ms ease-in-out 500ms both',
      keyframes: fadeInKeyframes,
    },
    fadeOut: {
      animation: 'fadeOut 500ms ease-in-out both',
      keyframes: fadeOutKeyframes,
    },
    expandedFadeIn: {
      animation: 'fadeIn 1s ease-in-out both',
      keyframes: fadeInKeyframes,
    },
  },

  // Expand content animations
  expandContent: {
    expand: {
      animation: 'expandContent 500ms ease-out both',
      keyframes: {
        '@keyframes expandContent': {
          '0%': {
            opacity: 0,
            transform: 'translateY(20px) scale(0.95)',
          },
          '100%': {
            opacity: 1,
            transform: 'translateY(0) scale(1)',
          },
        },
      },
    },
  },

  // Link animations
  link: {
    fadeIn: {
      animation: 'fadeIn 500ms ease-in-out 500ms both',
      keyframes: fadeInKeyframes,
    },
    fadeOut: {
      animation: 'fadeOut 500ms ease-in-out both',
      keyframes: fadeOutKeyframes,
    },
  },
  // Global CSS animations (for class-based animations)
  global: {
    fadeOut: {
      animation: 'fadeOut 1s ease-in-out 0s both !important',
      keyframes: fadeOutKeyframes,
    },
    fadeOutFast: {
      animation: 'fadeOut 500ms ease-in-out 0s both !important',
      keyframes: fadeOutKeyframes,
    },
  },
  // Buttons container animations
  buttonsContainer: {
    fadeIn: {
      animation:
        'fadeIn 1s ease-in-out, buttonsBounceSlideUp 1s ease-in-out both',
      keyframes: {
        ...fadeInKeyframes,
        '@keyframes buttonsBounceSlideUp': {
          '0%': { transform: 'translateY(24px)' },
          '100%': { transform: 'translateY(0)' },
        },
      },
    },
    fadeInOnly: {
      animation: 'fadeIn 1s ease-in-out both',
      keyframes: fadeInKeyframes,
    },
  },

  // Disclaimer animations
  disclaimer: {
    slideUp: {
      animation: 'disclaimerSlideUp 500ms ease-out 300ms both',
      keyframes: {
        '@keyframes disclaimerSlideUp': {
          '0%': { opacity: 0, transform: 'translateY(10px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      },
    },
  },
};
